module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_PL-ae1ef5b7f3d22c862bd9c34b9c3fd611.svg";